<template>
    <button
        :class="buttonClass"
        :disabled="isDisabled"
        @click="addToCart"
    >
        <slot>{{ lang('Köp', 'Add to cart') }}</slot>
    </button>
</template>

<script>
    export default {
        props: {
            articleClass: {
                type: String,
                required: true,
            },
            articleId: {
                type: Number,
                default: null,
            },
            classOverride: {
                type: String,
                default: null,
            },
            extraClass: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: null,
            },
            location: {
                type: String,
                default: null,
            },
            parameters: {
                type: [Object, null],
                default: null,
            },
        },

        computed: {
            buttonClass() {
                return this.classOverride
                    ? this.classOverride
                    : 'btn btn-sm is-primary ' + this.extraClass;
            },
            isDisabled() {
                if (! this.articleId) {
                    return true;
                }

                return this.disabled;
            },
        },

        methods: {
            async addToCart() {
                if (! this.articleId) {
                    return;
                }

                const article = {
                    articleClass: this.articleClass,
                    articleId: this.articleId,
                };

                if (this.parameters) {
                    article['parameters'] = this.parameters;
                }


                const response = await axios.post(route('front.api.cart-items.store'), {
                    articles: [article],
                });

                EventBus.$emit('cartDataUpdated', response.data, this.location);

                flash_success(lang('Varan har lagts till i varukorgen','The product has been added to your cart'));
            },
        },
    };
</script>
